export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '明星爆料',
    slug: 'star-gossip',
    description: '娱乐圈明星最新八卦、恋情曝光、翻车现场，一网打尽',
    icon: 'ri-star-line',
  },
  {
    id: 'cat-2',
    name: '社会热点',
    slug: 'social-hot',
    description: '社会热点事件深度爆料，第一时间掌握真相',
    icon: 'ri-fire-line',
  },
  {
    id: 'cat-3',
    name: '综艺影视',
    slug: 'variety-drama',
    description: '综艺节目幕后故事、影视剧独家爆料、剧组内幕',
    icon: 'ri-tv-line',
  },
  {
    id: 'cat-4',
    name: '网红圈',
    slug: 'influencer',
    description: '网红主播翻车现场、直播带货内幕、短视频圈八卦',
    icon: 'ri-live-line',
  },
  {
    id: 'cat-5',
    name: '情感吃瓜',
    slug: 'relationship',
    description: '明星恋情、婚姻爆料、分手大瓜、情感纠纷',
    icon: 'ri-heart-line',
  },
  {
    id: 'cat-6',
    name: '行业揭秘',
    slug: 'industry-expose',
    description: '娱乐圈潜规则、行业黑幕、资本博弈深度爆料',
    icon: 'ri-eye-line',
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}